import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import mountScript from "@dcl/ui/esm/utilities/mountScript";
import { YOUTUBE_SCRIPT_URL } from "./config";
export default /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
  var existingListener, youTubePromise, youTubeException;
  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!window.YT) {
            _context.next = 2;
            break;
          }

          return _context.abrupt("return", window.YT);

        case 2:
          existingListener = window.onYouTubeIframeAPIReady;
          youTubePromise = new Promise(function (resolve) {
            window.onYouTubeIframeAPIReady = function () {
              resolve(window.YT);
              window.onYouTubeIframeAPIReady = existingListener;

              if (window.onYouTubeIframeAPIReady) {
                var _window;

                (_window = window).onYouTubeIframeAPIReady.apply(_window, arguments);
              }
            };
          });
          _context.prev = 4;
          _context.next = 7;
          return mountScript(YOUTUBE_SCRIPT_URL);

        case 7:
          _context.next = 14;
          break;

        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](4);
          youTubeException = new Error("Unable to load the YouTube API: ".concat(_context.t0));
          youTubeException.name = "YouTubeLoadError";
          throw youTubeException;

        case 14:
          return _context.abrupt("return", youTubePromise);

        case 15:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, null, [[4, 9]]);
}));